import { Component, Input, OnInit, Output,EventEmitter, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';
import { Campaign3Wizard } from 'app/views/campaign-3/models/campaign-3-touchpoint.model';

@Component({
  selector: 'app-campaign-3-search-wizard',
  templateUrl: './campaign-3-search-wizard.component.html',
  styleUrls: ['./campaign-3-search-wizard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchWizardComponent implements OnInit {
  
  @Output() wizardSelected: EventEmitter<any> = new EventEmitter<any>();

  @Input() wizardList: Array<Campaign3Wizard> = [];
  
  paginationType: number = Campaign3KontableComponent.NoPagination;
  show = {
    table: false
  }
  
  constructor(

    ) {
  
  }
  ngOnInit() {
    
    this.show.table = true;
  
  }
  onWizardSelected(wizard: any){
    if(wizard)
      this.wizardSelected.emit(wizard);
    else this.wizardSelected.emit(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-wizard/campaign-3-search-wizard.component.ts